import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {
  GeckoModal,
  GECKO_CONSTS,
  GeckoModalService,
  GeckoToastService,
} from '../../../ui';
import { connect } from 'react-redux';
import GeckoLocation from '../../../services/gecko-location';
import { getUsableChannels } from 'selectors/channels/index.js';
import GeckoRequest from 'services/gecko-request';
import GeckoFeatures from 'services/gecko-features';

class NewTeamModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      teamName: '',
      teamMembers: [],
      channels: [],
      tooLong: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (this.props.existing) {
      this.setState({ teamName: this.props.existing.name });
    }
  }

  fields = [
    {
      key: 'teamName',
      label: 'Team Name',
      required: true,
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_NAME,
      errors: function (value) {
        if (!value) {
          return;
        }

        if (value.length > 255 ? true : false) {
          return 'Team name is too long';
        }
      },
    },
    ...(!this.props.existing.name && GeckoFeatures.can('team-channels')
      ? [
          {
            label: 'Add team members',
            key: 'teamMembers',
            type: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
            options: this.getAgents(),
            placeholder: 'Search Agents',
            width: '100',
          },
          {
            label: 'Channels',
            key: 'channels',
            type: GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI,
            options: this.getChannels(),
            placeholder: 'All Channels',
            width: '100',
          },
        ]
      : []),
  ];

  footerButtons = [
    {
      name: this.props.existing.name ? 'Done' : 'Create',
      type: 'primary',
      icon: 'far fa-check',
      handler: () => {
        if (!this.state.tooLong) {
          this.handleSubmit.bind(this)();
        }
      },
    },
  ];

  getAgents() {
    const allAgents = this.props.agents.map((agent) => {
      return {
        label: agent.full_name,
        value: agent.id,
      };
    });
    return allAgents;
  }

  getChannels() {
    const allChannels = this.props.channels.map((channel) => {
      return {
        label: channel.name,
        value: channel.id,
      };
    });
    return allChannels;
  }

  onUserInput(e, val) {
    var isItAye = val.length > 255 ? true : false;

    this.setState({
      [e]: val,
      tooLong: isItAye,
    });
  }

  handleSubmit() {
    if (
      this.props.existing &&
      this.props.existing.name === this.state.teamName
    ) {
      return new GeckoModalService().close();
    }
    if (!this.state.teamName || this.state.teamName.length === 0) {
      new GeckoToastService().error('Team name is required');
    } else if (this.props.teamNamesList.indexOf(this.state.teamName) > -1) {
      new GeckoToastService().error('A team with this name already exists');
    } else {
      if (this.props.existing && this.props.existing.name) {
        GeckoRequest.post(`/models/teams/${this.props.existing.id}`, {
          name: this.state.teamName,
        })
          .then(() => {
            new GeckoToastService().success('Team updated');
          })
          .catch((err) => new GeckoToastService().error(err));
      } else {
        GeckoRequest.post('/models/teams/', { name: this.state.teamName })
          .then(async (res) => {
            await Promise.all(
              this.state.teamMembers.map(async (teamMember) => {
                await GeckoRequest.post(`/models/agent_teams/`, {
                  agent_id: teamMember,
                  team_id: res.id,
                });
              })
            );

            await Promise.all(
              this.state.channels.map(async (channel) => {
                const currentChannel = this.props.channels.find(
                  (c) => c.id === channel
                );

                const assigned_team_ids = [
                  ...(currentChannel.assigned_team_ids || []),
                  res.id,
                ];

                await GeckoRequest.post(
                  `/channel/${currentChannel.id}/assign-teams`,
                  assigned_team_ids
                );
              })
            );

            new GeckoToastService().success('New team created successfully');
            GeckoLocation.goTo(`/teams/${res.id}`);
          })
          .catch((err) => new GeckoToastService().error(err));
      }

      return new GeckoModalService().close();
    }
  }

  render() {
    return (
      <GeckoModal
        name={this.props.existing.name ? 'Edit Name' : 'Add New Team'}
        fields={this.fields}
        values={{
          teamName: this.state.teamName,
          teamMembers: this.state.teamMembers,
          channels: this.state.channels,
        }}
        btns={this.footerButtons}
        handler={this.onUserInput.bind(this)}
      />
    );
  }
}

NewTeamModal.defaultProps = {
  current_user: {},
  defaultHeaders: {},
  teamNamesList: [],
  existing: {},
};

NewTeamModal.propTypes = {
  current_user: PropTypes.object,
  defaultHeaders: PropTypes.object,
  teamNamesList: PropTypes.array,
  existing: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    defaultHeaders: state.appState.defaultHeaders,
    current_user: state.appState.loggedInUser,
    agents: state.agents,
    channels: getUsableChannels(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(NewTeamModal);
